var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-black is-fullheight"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabs is-toggle is-fullwidth is-small"
  }, [_c('ul', _vm._l((_vm.views), function(view, index) {
    return _c('li', {
      key: ("view-" + index),
      class: {
        'is-active': _vm.isViewActive(view.value)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.updateSelection(view.value)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(view.name)))])])])
  }))])])]), _vm._v(" "), (_vm.selectedView === 'collection') ? _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.collections), function(collection, index) {
    return _c('div', {
      key: ("collection-" + index)
    }, [_c('ArchiveCollection', {
      attrs: {
        "collection": collection,
        "objects": _vm.objects
      },
      on: {
        "open-details": _vm.showObjectDetails
      }
    })], 1)
  }))]) : _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ArchiveGrid', {
    attrs: {
      "objects": _vm.objects
    },
    on: {
      "open-details": _vm.showObjectDetails
    }
  })], 1)]), _vm._v(" "), (_vm.currentDetails) ? _c('archive-details', {
    attrs: {
      "isActive": _vm.modalVisible,
      "details": _vm.currentDetails
    },
    on: {
      "close-details": _vm.hideObjectDetails
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('strong', [_vm._v("Archive")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4724d95a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive.vue
// module id = MFQg
// module chunks = 0